import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ImageLink } from "../constants";
import PDF from "./pdf.png"

const ProjectPlan = () => {
  const [loading, setLoading] = useState(true);
  const [planData, setPlanData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [projectFilter, setProjectFilter] = useState(
    sessionStorage.getItem("projectFilter") || ""
  );
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    parseInt(sessionStorage.getItem("currentPage")) || 1
  );
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const navigator = useNavigate();
  const perPage = 10;

  const fetchData = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(`project/getAllProjectPlan`, {
        perPage: perPage,
        pageNo: page,
        projectId: projectFilter || null
      });
      const { data, totalPages } = response.data;
      setPlanData(data);
      setTotalPages(totalPages);
      setCurrentPage(page);
      sessionStorage.setItem("currentPage", page);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, projectFilter]);

  const fetchProjectData = async () => {
    try {
      const response = await axiosInstance.get(`project/getWithoutPaginationProject`);
      const { data } = response.data;
      setProjectData(data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Something went wrong. Please try again!!');
      }
    }
  };

  useEffect(() => {
    fetchProjectData();
  }, []);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) {
    return <p>Loading.....</p>;
  }

  const handleDelete = async (id) => {
    setDeleteItemId(id);
    setModalOpen(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await axiosInstance.delete(
        `project/deleteProjectPlan/${deleteItemId}`
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        fetchData(currentPage);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again!!");
      }
    } finally {
      setDeleteItemId(null);
      setModalOpen(false);
    }
  };

  const handleFilterChange = (e) => {
    const selectedProjectFilter = e.target.value;
    setProjectFilter(selectedProjectFilter);
    sessionStorage.setItem("projectFilter", selectedProjectFilter);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalPagesToShow = 5;

    let startPage = Math.max(1, currentPage - Math.floor(totalPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + totalPagesToShow - 1);

    if (endPage - startPage + 1 < totalPagesToShow) {
      startPage = Math.max(1, endPage - totalPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageClick(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (startPage > 1) {
      pageNumbers.unshift(
        <li key="left-dots" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (endPage < totalPages) {
      pageNumbers.push(
        <li key="right-dots" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    return pageNumbers;
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="page-title">Project Plan</h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/add-plan">
                  <button type="button" className="btn btn-inverse-info btn-fw">
                    <i className="icon-plus mx-2 mt-2"></i>Add Plan
                  </button>
                </Link>
              </li>
            </ol>
          </nav>
        </div>
        <div className="row">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="d-sm-flex align-items-center mb-4">
                  <div className="form-group row">
                    <label
                      htmlFor="exampleInputUsername1"
                      className="col-sm-3 col-form-label"
                    >
                      Project
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="form-control form-control-lg"
                        id="exampleFormControlSelect1"
                        name='projectId'
                        value={projectFilter}
                        onChange={handleFilterChange}
                      >
                        <option value="" disabled>-- Please Select Project --</option>
                        <option value="">All Projects</option>
                        {projectData.map(item => (
                          <option key={item._id} value={item._id}>{item.title}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="table-responsive border rounded p-1">
                  <table className="table text-center">
                    <thead>
                      <tr>
                        <th className="font-weight-bold">Position</th>
                        <th className="font-weight-bold">Project Name</th>
                        <th className="font-weight-bold">Title</th>
                        <th className="font-weight-bold">Type</th>
                        <th className="font-weight-bold">Plan Img/pdf</th>
                        <th className="font-weight-bold">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {planData.length > 0 ? (
                        planData.map((item, index) => (
                          <tr key={index}>
                            <td>{item.position}</td>
                            <td>{item?.projectId?.title}</td>
                            {item?.title ? (
                              <td>{item.title}</td>
                            ) : (
                              <td>-</td>
                            )}

                            <td>{item?.planTabId?.title}</td>
                            <td>
                              {item?.planTabId?.title === 'Plan' && (
                                <img
                                  className="img-sm rounded-circle"
                                  src={ImageLink(item.desktopImg)}
                                  alt="Banner"
                                />
                              )}
                              {item?.planTabId?.title === 'Documents' && (
                                <Link to={ImageLink(item.desktopImg)} target="_blank">
                                  <img src={PDF} alt="pdf" className="ms-3 me-3" width={60} />
                                </Link>
                              )}
                            </td>
                            <td>
                              <div className="template-demo">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-icon-text btn-sm w-40"
                                  onClick={() => {
                                    navigator("/add-plan", {
                                      state: item,
                                    });
                                  }}
                                >
                                  <i className="icon-pencil btn-icon-append mr-1"></i>{" "}
                                  Edit
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-icon-text btn-sm w-35"
                                  onClick={() => handleDelete(item._id)}
                                >
                                  <i className="icon-trash btn-icon-append"></i>{" "}
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">No data found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex mt-4 flex-wrap">
                  <p className="text-muted">
                    Showing {(currentPage - 1) * perPage + 1} to{" "}
                    {Math.min(currentPage * perPage, planData.length)} of{" "}
                    {totalPages * perPage} entries
                  </p>
                  <nav className="ml-auto">
                    <ul className="pagination separated pagination-info">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(currentPage - 1)}
                        >
                          <i className="icon-arrow-left" />
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(currentPage + 1)}
                        >
                          <i className="icon-arrow-right" />
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalHeader>Confirm Delete</ModalHeader>
        <ModalBody>Are you sure you want to delete this plan?</ModalBody>
        <ModalFooter>
          <div className="">
            <Button
              type="cancel"
              className="btn btn-success btn-fw"
              onClick={() => setModalOpen(!modalOpen)}
            >
              No
            </Button>
          </div>
          <div className="">
            <Button
              type="button"
              className="btn btn-danger btn-fw"
              onClick={confirmDelete}
            >
              Yes
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ProjectPlan;
